import type { UserDomainQueryModel } from '@mntn-dev/domain-types'
import type { AuthUser } from './auth-user.ts'

type UserInfo = Pick<
  UserDomainQueryModel,
  | 'userId'
  | 'emailAddress'
  | 'firstName'
  | 'lastName'
  | 'displayName'
  | 'avatar'
>

export const getAuthUser = (user: UserInfo): AuthUser => ({
  sub: user.userId,
  email: user.emailAddress,
  given_name: user.firstName,
  family_name: user.lastName,
  name: user.displayName,
  nickname: user.displayName,
  picture: user.avatar?.fileId,
})
